import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal fade show",
  style: {"display":"block"}
}
const _hoisted_2 = { class: "modal-dialog wise-modal" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "d-flex justify-content-end" }
const _hoisted_8 = ["title"]
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-12 form-group" }
const _hoisted_12 = { for: "recipients" }
const _hoisted_13 = {
  key: 0,
  class: "col-md-12 form-group"
}
const _hoisted_14 = { for: "recipientsCC" }
const _hoisted_15 = {
  key: 1,
  class: "col-md-12 form-group"
}
const _hoisted_16 = { for: "recipientsBCC" }
const _hoisted_17 = { for: "EmailFrom" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = ["value"]
const _hoisted_20 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_21 = { for: "EmailSubject" }
const _hoisted_22 = ["placeholder", "disabled"]
const _hoisted_23 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_24 = { class: "col-md-12 form-group mb-5" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"25px"} }, null, -1)
const _hoisted_26 = { class: "modal-footer" }
const _hoisted_27 = { class: "d-flex justify-content-end" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_jw_tag_input_v2 = _resolveComponent("jw-tag-input-v2")!
  const _component_QuillEditor = _resolveComponent("QuillEditor")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.language.compose_email), 1),
              (!_ctx.isSending)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeFormRet && _ctx.closeFormRet(...args))),
                    type: "button",
                    class: "btn-close"
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("a", {
                  href: "javascript:;",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeVisibleCC())),
                  title: !_ctx.isCCVisible ? _ctx.language.show_recipients_cc: _ctx.language.hide_recipients_cc
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["bi text-danger", {'bi-eye-fill': !_ctx.isCCVisible, 'bi-eye-slash-fill': _ctx.isCCVisible}])
                  }, null, 2)
                ], 8, _hoisted_8),
                _createTextVNode("  "),
                _createElementVNode("a", {
                  href: "javascript:;",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeVisibleBCC())),
                  title: !_ctx.isBCCVisible ? _ctx.language.show_recipients_bcc: _ctx.language.hide_recipients_bcc
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["bi text-primary", {'bi-eye': !_ctx.isBCCVisible, 'bi-eye-slash': _ctx.isBCCVisible}])
                  }, null, 2)
                ], 8, _hoisted_9)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.language.add_recipient), 1),
                  _createVNode(_component_jw_tag_input_v2, {
                    initialTags: _ctx.recipients,
                    onAfterUpdate: _ctx.updateRecipients,
                    disabled: _ctx.isSending,
                    emailActivated: true,
                    placeholder: _ctx.language.add_new_rec_email
                  }, null, 8, ["initialTags", "onAfterUpdate", "disabled", "placeholder"])
                ]),
                (_ctx.isCCVisible)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.language.add_recipient + ' (CC)'), 1),
                      _createVNode(_component_jw_tag_input_v2, {
                        initialTags: _ctx.recipientsCC,
                        onAfterUpdate: _ctx.updateRecipientsCC,
                        disabled: _ctx.isSending,
                        emailActivated: true,
                        placeholder: _ctx.language.add_new_rec_email_cc
                      }, null, 8, ["initialTags", "onAfterUpdate", "disabled", "placeholder"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isBCCVisible)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.language.add_recipient + ' (BCC)'), 1),
                      _createVNode(_component_jw_tag_input_v2, {
                        initialTags: _ctx.recipientsBCC,
                        onAfterUpdate: _ctx.updateRecipientsBCC,
                        disabled: _ctx.isSending,
                        emailActivated: true,
                        placeholder: _ctx.language.add_new_rec_email_bcc
                      }, null, 8, ["initialTags", "onAfterUpdate", "disabled", "placeholder"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(["col-md-12 form-group", {'has-error': _ctx.v$.dataRecord.EmailFrom.$error}])
                }, [
                  _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.language.from), 1),
                  _withDirectives(_createElementVNode("select", {
                    id: "EmailFrom",
                    name: "EmailFrom",
                    class: "form-control-sel",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dataRecord.EmailFrom) = $event)),
                    disabled: _ctx.isSending
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listOfEmailAccts, (emailFrom) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: emailFrom.AccountKey,
                        value: emailFrom.AccountEmail
                      }, _toDisplayString(`${emailFrom.AccountName} <${emailFrom.AccountEmail}>`), 9, _hoisted_19))
                    }), 128))
                  ], 8, _hoisted_18), [
                    [_vModelSelect, _ctx.dataRecord.EmailFrom]
                  ]),
                  (_ctx.v$.dataRecord.EmailFrom.$error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.v$.dataRecord.EmailFrom.$errors[0].$message), 1))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["col-md-12 form-group", {'has-error': _ctx.v$.dataRecord.EmailSubject.$error}])
                }, [
                  _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.language.subject), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "EmailSubject",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dataRecord.EmailSubject) = $event)),
                    placeholder: '(' + _ctx.language.subject.toLowerCase() + ')',
                    maxlength: "150",
                    autocomplete: "off",
                    onFocus: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectOnFocus($event))),
                    disabled: _ctx.isSending
                  }, null, 40, _hoisted_22), [
                    [_vModelText, _ctx.dataRecord.EmailSubject]
                  ]),
                  (_ctx.v$.dataRecord.EmailSubject.$error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.v$.dataRecord.EmailSubject.$errors[0].$message), 1))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_QuillEditor, {
                    theme: "snow",
                    toolbar: "essential",
                    content: _ctx.editorContent,
                    "onUpdate:content": _ctx.onHtmlChange,
                    ref: "htmlEditor"
                  }, null, 8, ["content", "onUpdate:content"])
                ]),
                _hoisted_25
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary me-2",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.closeFormRet && _ctx.closeFormRet(...args))),
                  disabled: _ctx.isSending
                }, _toDisplayString(_ctx.language.close), 9, _hoisted_28),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.sendRecordEmail && _ctx.sendRecordEmail(...args))),
                  disabled: _ctx.v$.$invalid || _ctx.isSending
                }, [
                  (!_ctx.isSending)
                    ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                        key: 0,
                        icon: ['fa', 'fa-save']
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.isSending)
                    ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                        key: 1,
                        icon: ['fa', 'fa-spinner']
                      }))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.language.send), 1)
                ], 8, _hoisted_29)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}